package com.wiz3r.database

import kotlin.Long
import kotlin.String

public data class Advice_cards(
  public val id: String,
  public val category: String,
  public val title: String,
  public val content: String,
  public val icon: String?,
  public val priority: Long?,
  public val is_active: Long?,
  public val country: String?,
)
